import { DotDivider } from 'component/DotDivider/DotDivider'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { DashedButton } from 'page/ProfileScreen/basic/DashedButton'
import { SectionTitle } from 'page/ProfileScreen/basic/SectionTitle'
import { StandCameraPanel } from 'page/ProfileScreen/Selfies/StandCameraPanel'
import { store } from 'store/store'

export const StandSelfiesPanel = observer(() => {
  const onHelp = useLatestCallback(() => {
    store.profile.step = 'help'
  })

  return <Vertical gap={32}>
    <Space />
    <DotDivider />
    <Space height={32} opposite>
      <Space>
        <SectionTitle>
          {i18n('profile.Selfie')}
        </SectionTitle>
        <Space pin={[32, null, null, 0]} width={300}>
          <Typo size={16} pre>
            {i18n('SelfieStandDesc')}
          </Typo>
        </Space>
      </Space>
      <DashedButton onClick={onHelp}>
        {i18n('HowToTakeSelfie')}
      </DashedButton>
    </Space>
    <StandCameraPanel />
    <DotDivider />
  </Vertical>
})
